import { render, staticRenderFns } from "./delete-group.vue?vue&type=template&id=599124df&scoped=true"
import script from "./delete-group.vue?vue&type=script&lang=js"
export * from "./delete-group.vue?vue&type=script&lang=js"
import style0 from "./delete-group.vue?vue&type=style&index=0&id=599124df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599124df",
  null
  
)

export default component.exports